export default "__VITE_ASSET__CryF1vzo__"